import { render, staticRenderFns } from "./RollingDisplay.vue?vue&type=template&id=0602639e&scoped=true&"
import script from "./RollingDisplay.vue?vue&type=script&lang=js&"
export * from "./RollingDisplay.vue?vue&type=script&lang=js&"
import style0 from "./RollingDisplay.vue?vue&type=style&index=0&id=0602639e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0602639e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
